import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import React from "react";
import { PaymentMethod, useShoppingCart } from "../context/ShoppingCartContext";
import { useAppSelector } from "../../../store/hooks";
import usePageLanguage from "../hooks/usePageLanguage";
import { CheckoutPaymentMethod } from "../utilities/checkoutTypes";
import {
  getPaymentStepNumber,
  useCheckoutConfig,
} from "./checkoutConfig";
import CheckoutLegalConsentLinks from "./CheckoutLegalConsentLinks";

interface Props {
  show: boolean;
  setShow: (val: boolean) => void;
  paymentMethod: PaymentMethod | null;
  setShowParentModal?: (val: boolean) => void;
  onPaymentSelected?: () => void;
}

const languageTranslations = {
  et: {
    payment_method: "MAKSEVIIS",
    payment_channel:
      "Kliki selle maksekanali logo peale, mida soovid kasutada.",
    agree_terms: "NÕUSTUN TINGIMUSTEGA JA SALVESTAN",
  },
  en: {
    payment_method: "PAYMENT METHOD",
    payment_channel:
      "Click on the logo of the payment channel you want to use.",
    agree_terms: "AGREE WITH TERMS AND SAVE",
  },
};

export default function CheckoutMaksekeskusModal({
  show,
  setShow,
  paymentMethod,
  setShowParentModal,
  onPaymentSelected,
}: Props) {
  const { setPaymentMethod } = useShoppingCart();
  const pageId = useAppSelector((state) => state.builder.pages.active);
  const locale = usePageLanguage();
  const checkoutConfig = useCheckoutConfig();
  const paymentStep = getPaymentStepNumber(checkoutConfig);

  const { handleSubmit, register } = useForm<{
    maksekeskusPaymentMethodName?: string;
  }>({
    mode: "all",
  });

  const onSubmit = (data: { maksekeskusPaymentMethodName?: string }) => {
    const mergedPaymentMethod = { ...paymentMethod, ...data };
    if (!data.maksekeskusPaymentMethodName) {
      delete mergedPaymentMethod.maksekeskusPaymentMethodName;
    }
    setShowParentModal!(false);
    setPaymentMethod(mergedPaymentMethod as CheckoutPaymentMethod);
    setShow(false);
    if (onPaymentSelected) {
      onPaymentSelected();
    }
  };

  return (
    <Modal
      show={show}
      onHide={() => {
        setShow(false);
      }}
      contentClassName="modal-600 paymentMethodModal shop-controlled-border-radius"
    >
      <Modal.Header
        closeButton
        style={{
          borderTopLeftRadius: "var(--shop-border-radius)",
          borderTopRightRadius: "var(--shop-border-radius)",
        }}
      >
        <Modal.Title>
          <span className="badge badge-square badge-primary me-3">{paymentStep}</span>
          <span className="fw-bold">
            {languageTranslations[locale]?.payment_method}
          </span>
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <div className="row margin-top-5 padding-10">
            <button className="btn btn-primary-outline col-xs-12 text-left paymentMethodButtonTitle">
              <span className="mk-payment-title">
                {paymentMethod?.translations?.[locale]?.name}
              </span>
            </button>
          </div>

          <div className="row margin-top-10">
            <div className="col-xs-12" style={{ fontSize: "15px" }}>
              {languageTranslations[locale]?.payment_channel}
            </div>
          </div>

          <div className="row margin-top-20">
            <div className="col-xs-12">
              <div className="mk-payment-options">
                {paymentMethod?.apiClient &&
                paymentMethod.apiClient.maksekeskusPaymentMethods
                  ? paymentMethod.apiClient.maksekeskusPaymentMethods.map(
                      (mpm) => (
                        <label
                          key={mpm.name}
                          className="mk-payment-options__option"
                        >
                          <input
                            {...register("maksekeskusPaymentMethodName", {
                              required: false,
                            })}
                            type="radio"
                            value={mpm.name}
                            style={{ display: "none" }}
                          />
                          <img src={mpm.logoUrl} alt="" />
                        </label>
                      )
                    )
                  : ""}
              </div>
            </div>
          </div>

          <CheckoutLegalConsentLinks
            legalLinks={checkoutConfig.legalLinks}
            locale={locale}
          />
        </Modal.Body>
        <Modal.Footer>
          <button
            type="submit"
            style={{
              color: "#fff",
              fontWeight: "600",
            }}
            className="btn w-100 shop-controlled-border-radius shop-controlled-color"
          >
            {languageTranslations[locale]?.agree_terms}
          </button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
